export const categories = [
  {
    id: 1,
    slug: "mingxing",
    name: "明星八卦",
    icon: "ri-user-star-line",
    description: "圈内动向、剧组花絮、艺人回应，第一时间跟进。",
    accent: "primary",
  },
  {
    id: 2,
    slug: "shehui",
    name: "社会趣事",
    icon: "ri-community-line",
    description: "街头巷尾的真实故事，笑点与暖意并存。",
    accent: "accent",
  },
  {
    id: 3,
    slug: "wangluo",
    name: "网络热闻",
    icon: "ri-fire-line",
    description: "全网刷屏的话题、热梗与争议，一站看全。",
    accent: "primary",
  },
  {
    id: 4,
    slug: "qinggan",
    name: "情感八卦",
    icon: "ri-heart-3-line",
    description: "情感话题与两性观察，聊聊那些说不清的事。",
    accent: "secondary",
  },
  {
    id: 5,
    slug: "yingshi",
    name: "影视综艺",
    icon: "ri-movie-2-line",
    description: "热播剧综的口碑、名场面与幕后故事。",
    accent: "accent",
  },
];